<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[expenseitems$]"></ef-loading-container>
<ef-expense-item-presenter 
  [expenseItems] = 'expenseitems$ | async' 
  [process] = 'process$ | async'  
  (SaveExpenseItems)="onSaveExpenseItems($event)"
  (LoadExpenseItems)="onLoadExpenseItems($event)"
  [selectedError]="selectedErrorWithStatus$ | async"
  (ShowError)="this.ShowError.next($event)"
>
</ef-expense-item-presenter>
